export class InternalError extends Error {
  status = 0;
  cause: Error;
  needLogin = false;
  // Will be ignored for the purpose of the `displayError` middleware.
  silent = false;

  constructor(
    message: string,
    needLogin = false,
    cause?: string,
    silent = false
  ) {
    super();

    this.message = message;
    this.needLogin = needLogin;
    this.silent = silent;

    this.cause = new Error(cause || message);
  }

  setMessage(message: string) {
    this.message = message;
  }

  toString() {
    return 'Error: ' + this.message;
  }
}
